import type { StepConfig } from '../../../../../technical/wizard/StepConfig.ts';
import AllocationConstraintsStep from './AllocationConstraintsStep.tsx';
import type { YieldOptimizerInputFields } from '../YieldOptimizer.validation.ts';

export const config = (goToNextStep: () => void): StepConfig<YieldOptimizerInputFields> => ({
  label: 'Allocation constraints',
  element: <AllocationConstraintsStep goToNextStep={goToNextStep} />,
  fields: ['constraints'],
});
